'use client';
import { useTranslation } from 'react-i18next';

import { swal } from '@/lib/sweetalert';
import { UrlShare as CommonUrlShare, type UrlShareProps } from '@monorepo/common';

function UrlShare({ url, twitterShareText }: UrlShareProps) {
  const { t } = useTranslation();
  const handleCopySuccess = async () => {
    await swal.messages({ messages: [t('urlCopied')] });
  };

  const shareText = t('share');

  return (
    <CommonUrlShare
      url={url}
      twitterShareText={twitterShareText}
      onCopySuccess={handleCopySuccess}
      shareText={shareText}
    />
  );
}

export default UrlShare;
